export default {
  'm': {
    'uploading': '上传中...',
    'upload_failed': '上传失败',
    'EnterID': '点击输入 BuzzCast ID',
    'select-specifications': '点击选择充值规格',
    'check-account': '核对充值账号',
    'whatID': '什么是 BuzzCast ID ？',
    'getID': '输入 BuzzCast ID',
    'maskgetID': '输入 BuzzCast ID',
    'toastTips-format-error': '输入格式有误',
    'toastTips-no-exist': '该ID不存在',
    'toastTipsPlease': '请先核对充值账号',
    'common-problem': '常见问题',
    'transaction-succeeded': '交易成功',
    'transaction-failed': '交易失败',
    'transaction-cancel': '交易取消',
    'whether-account': '1.我充值后怎么查看是否到账？',
    'answer-whether-account': '充值后可回到 APP 的【我的】-【钱包】中查看钻石',
    'no-account': '2.充值后若是没有到账怎么办？',
    'answer-no-account': '请在 APP 的【消息】-【官方消息】-【反馈与帮助】中提交您的问题，并提供以下信息，我们的客服将为您提供帮助。',
    'recharge-money': '1.充值金额和账户 ID',
    'recharge-time': '2.充值的时间和日期',
    'recharge-shot': '3.支付成功的屏幕截图',
    'recharge-wrong': '3.充错账户，充错金额怎么办',
    'answer-recharge-wrong': '请您在输入支付密码前，务必仔细确认充值账户 ID 和充值金额信息后再进行购买。错充金额无法退还，错充账户您可尝试与实际充值的 ID 用户联系，与对方协商是否愿意补偿您的充值。',
    'refund': '4.退款',
    'answer-refund': '抱歉！BuzzCast 目前不支持任何形式的退款。',
    'buy-enter-link': '购买钻石可通过链接进行充值，<a class="web-link" href="https://pay.buzzcast.info">https://pay.buzzcast.info</a> 将链接复制在手机浏览器中打开，进入购买页面，核对账号后，选择相应的规格并使用合适的支付方式进行支付即可～ 优惠多多！',
    'buy-notice-a': '注意: <a>{msg}</a> 是 BuzzCast 唯一官方购买钻石网址',
    'replace': '更换',
    'sureBtn': '确定',
    'pay-style': '选择支付方式',
    'goBack': '回到首页',
    'toastTips': '输入 BuzzCast ID',
    'rechargeFAQ_title': '常见问题',
    'PayStatusSuccess_title': '交易成功',
    'PayStatusFail_title': '交易失败',
    'PayStatusCancel_title': '交易取消',
    'Diamonds_title': '{msg} 钻石充值官方网站',
    'buy-notice': '注意  pay.buzzcast.info 是 BuzzCast 唯一官方购买钻石网站，客服咨询请进入【消息】-【官方消息】-【反馈与帮助】',
    'RechargeHelp_title': '充值帮助',
    'feedback_and_help': '反馈与帮助',
    'problem_screenshot': '问题截图/录屏（{msg}）',
    'problem_description': '问题描述',
    'problem_description_placeholder': '请描述您遇到的问题',
    'optional': '选填',
    'required': '必选',
    'openAPP': '打开 BuzzCast APP',
    'buy-diamonds-tit': '购买钻石服务',
    'description': 'BuzzCast 唯一官方钻石充值网站 ， BuzzCast 是一款国际化社交软件，全球超过150多个国家和地区的用户正在使用 BuzzCast',
    'keywords': 'BuzzCast 充值,BuzzCast 钻石充值,BuzzCast 官方充值,BuzzCast 官方充值网站',
    'wxPay': '请确认微信支付是否已完成',
    'Completed': '已完成支付',
    'failedPay': '支付遇到问题,重新支付',
    'toastTips-no-complete': '支付未完成，请重新支付',
    'payforType': '充值方式',
    'trueText': '确定',
    'falseText': '取消',
    'alertShowTxt1': '确定用',
    'alertShowTxt3': '充值',
    'alertShowTxt5': '钻石？',
    'EnterIDTip': '{msg}快速充值',
    'scanLogin': ' 为了账户隐私和安全，请扫码登录',
    'scanTip': ' 提示：点击 BuzzCast “个人中心/动态”右上角“扫一扫”扫码登录，同时支持识别二维码截图的方式登录',
    'scanVersion': ' 请升级 BuzzCast 到 %s 版本后扫码登录',
    'delAccount': ' 账号删除',
    'logout': '退出',
    'submit': '提交',
    'email_place_holder': '请输入您的邮箱地址',
    'fill_in_email_address': '请填写邮箱地址',
    'fill_in_all_required': '请输入问题描述',
    'order_exception_notice': '温馨提示：充值订单异常问题必须提供订单号或账单截图',
    'cannot_read_file': '无法读取文件',
    'submitting': '提交中...',
    'submit_failed': '提交失败',
    'contact_email': '联系邮箱',
    'provide_email': '请提供您的电子邮箱来接收付款通知',
    'email_address': '电子邮箱地址',
    'sel_country_area': '选择国家或地区',
    'search_for': '搜一搜',
    'login': '登录',
    'scan_login': '扫码登录',
    'account_password_error': '手机号或密码有误',
    'user_frozen': '该用户已被冻结',
    'account_no_reg': '账号未注册',
    'login_no': '您还没有登录',
    'login_after_recharge': '登录后即可充值',
    'scan_login_lesson': '扫码登录教程',
    'scan_login_desc': '扫码登录方式可快捷、安全的实现充值网站登录，下面将从两种方式分别介绍如何进行扫码登录。',
    'scan_login_a_title': '识别二维码截图的方式登录',
    'scan_login_a_p1': '1、更加适合于单台设备使用场景，用户进入充值网站登录页面，点击选择“扫码登录”，将展示有登录二维码的页面截图，并保存相册。（截图功能不同设备略有差别，可自行搜索截图功能操作说明）',
    'scan_login_a_p2': '2、打开 BuzzCast APP，可通过“个人中心”或“动态”功能模块，点击右上角“扫一扫”，进入扫码功能模块。',
    'scan_login_a_p3': '3、点击“相册选取”，并允许相册权限，选择已保存的二维码登录页面截图，系统识别后点击“登录”确认按钮，切回浏览器稍作等待，页面即会自动加载用户信息。',
    'scan_login_b_title': '扫描二维码的方式登录',
    'scan_login_b_p1': '1、更加适合于多台设备使用场景，用户进入充值网站登录页面，点击选择“扫码登录”',
    'scan_login_b_p2': '2、另一台设备打开 BuzzCast APP，可通过“个人中心”或“动态”功能模块，点击右上角“扫一扫”，进入扫码功能模块。',
    'scan_login_b_p3': '3、将扫码框对准扫码登录页面二维码，系统识别后点击“登录”确认按钮（建议扫码时设备之间保持一定距离，更便于系统识别），稍作等待页面即会自动加载用户信息。',
    'scan_login_lesson_end': '以上是对扫码登录的教程指引，希望能够帮到您。客服咨询请进入APP端消息-官方消息-反馈与帮助。',
    'or': '或',
    'input_phone_num': '请输入您的手机号码',
    'input_email': '请输入邮箱账号',
    'input_password': '输入密码',
    'log_in_using_Facebook': '使用 Facebook 登录',
    'log_in_using_Google': '使用 Google 登录',
    'account_or_pwd_error': '账号或密码有误',
    'login_error_relogin': '登录异常，请在app端用该方式重新登录后，再返回网页登录',
    'pay_fail_system_risk': '交易失败：系统异常',
    'recharge_fail_risk_network': '充值失败，你可能处于高风险的网络环境下或其他原因。若你需要充值帮助，请向我们反馈你的问题。',
    'friendly_tip': '温馨提示',
    'i_got_it': '我知道了',
    'android_fblogin_tip': '因 Facebook 不再支持 Android 嵌入式浏览器上的身份验证登录，您在进行该方式登录时，可能出现无法登录的情况。若遇到此类无法登录问题请使用 Chrome 浏览器进行访问。',
    'recharge_tip': '具体到账钻石数量以实际充值金额为准',
    'sys_error': '参与人数较多，请稍后重试',
    'charge': '充值',
    'link_add_mainpage': '将链接添加到主屏幕，方便下次充值',
    'click_me_to_add': '点我添加',
    'reg_success_go_app': '注册成功，请下载APP登录结交更多朋友',
    'user_has_delete': '该用户已注销',
    'sel_one_account': '请选择您要登录的账户',
    'auth_beoverdue_relogin': '会话已过期，请您重新登录',
    'support_contant_whatsapp': '如需要支持请联系客服 {msg} App：1924383',
    'buy_balance': '可购买余额:',
    'official_coin_seller': '官方币商',
    'paystyle_unavailabel_change_other': '系统异常，该支付方式暂不可用，您可更换其他方式支付。',
    "copied": "已复制",
    "reseller": "币商",
    "netword_busy_try": "网络繁忙，请重试",
    "placecommen": '请输入搜索内容',
    "app_all_v2": '所有',
		"use_phone_login": `使用手机登录`,
    "use_email_login": `使用邮箱登录`,
    "device_is_more": "此设备注册账号数已达上限",
    "Operation_failed": "该设备因账号违规已被永久冻结",
    "connection_fail_retry_feedback": "连接失败，请确保网络畅通并再次尝试。若仍遇到错误，请向我们反馈，我们将第一时间为你解决。",
    "fawry_recharge_failed": "{method} 充值 ${msg} 失败",
    "feedback": "反馈",
    "problem_feedback": "问题反馈",
    "recommended_recharge_methods": "推荐的充值方式",
    "try_recharge_methods": "请尝试使用以下方式进行充值，若仍有问题，点击下方的「{feedback}」与我们取得联系",
    "unable_recharge": "无法充值",
    "submitted_successfully": "提交成功",
    "feedback_success_tip": "感谢您的反馈，我们会在24小时内尽快处理",
    "completed": "完成",
    'contact_information': '联系方式（选填）',
    'pay_failed': '支付失败',
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/zh.js